var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.657 5.30377C14.533 2.23077 9.468 2.23077 6.344 5.30377C5.60228 6.02841 5.0129 6.894 4.61051 7.84968C4.20812 8.80536 4.00083 9.83184 4.00083 10.8688C4.00083 11.9057 4.20812 12.9322 4.61051 13.8879C5.0129 14.8435 5.60228 15.7091 6.344 16.4338L12 21.9988L17.657 16.4338C18.3987 15.7091 18.9881 14.8435 19.3905 13.8879C19.7929 12.9322 20.0002 11.9057 20.0002 10.8688C20.0002 9.83184 19.7929 8.80536 19.3905 7.84968C18.9881 6.894 18.3987 6.02841 17.657 5.30377ZM12 13.4988C11.332 13.4988 10.705 13.2388 10.232 12.7668C9.76375 12.2975 9.50077 11.6617 9.50077 10.9988C9.50077 10.3359 9.76375 9.70002 10.232 9.23077C10.704 8.75877 11.332 8.49877 12 8.49877C12.668 8.49877 13.296 8.75877 13.768 9.23077C14.2362 9.70002 14.4992 10.3359 14.4992 10.9988C14.4992 11.6617 14.2362 12.2975 13.768 12.7668C13.296 13.2388 12.668 13.4988 12 13.4988Z",
    fill: "#A3A3A3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.e853b9e10b21f6e4daaf99b74d77cd4e.svg";
export { ForwardRef as ReactComponent };